<template> 
  <div id="action" class="action">
  <loading :active.sync="isLoading" 
  :can-cancel="true" 
  :is-full-page="fullPage"></loading>
     <button class="badge badge-info" @click="brandDetail()"><i class="material-icons">remove_red_eye</i></button>
      <!-- <router-link :to="{ name: 'brandDetail', params: { brandId: index, page: 'brandlist' }}"><button class="badge badge-info"><i class="material-icons">remove_red_eye</i></button></router-link> -->
      <button class="badge badge-secondry editBtn" id="editBtn" v-on:click="editBrand()"><i class="material-icons editBtn">edit</i></button>
      <button class="badge badge-danger"  
           v-confirm="{ loader: false, ok: deleteBrand, message: 'Do you really want to delete?'}" ><i class="material-icons">delete</i></button>
    
    </div>
</template>
<script>
  import axios from 'axios'
  import EditBrandModal from './EditBrandModal.vue'
 import Brands from './Brands.vue'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    name: 'brandAction',
    props: ['row', 'data'],
    components: { Brands,
      Loading
    },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        brands: [],
        errors: [],
        errormessage: ''
      }
    },
    methods: {
      deleteBrand () {
          let jwttoken = localStorage.getItem('jwt')
          let uid = this.row.uid
          this.isLoading = true
          axios.delete('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/deleteBrand' + '?' + 'uid' + '=' + uid, {
            headers: {
              'x-access-token': jwttoken
            }})
            .then(response => {
               this.isLoading = false
               this.$eventBus.$emit('listBrand', 'Brand is deleted successfully');
            }).catch(function(error) {
                 this.isLoading = false
                 this.$eventBus.$emit('listBrand', false,'Brand could not be deleted');
              });

      },
      brandDetail () {
        let location = '/brandDetail' + '/' + this.row.uid + '/' + 'brandlistpage'
        this.$router.push(location);
      },
      editBrand () {
        this.isLoading = true
        var jwttoken = localStorage.getItem('jwt')
        let uid = this.row.uid
        axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getBrandById' + '?' + 'uid' + '=' + uid, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            this.isLoading = false
            this.$modal.show(EditBrandModal, { brandDetails: response.data.results[0] }, { height: '100%' })
          })
          .catch((error) => {
            console.log(error)
            this.isLoading = false
          })
      }
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/brandAction.vue